
import * as UserModule from './user/user.module';
import * as HomeModule from './home/home.module';
import * as aboutModule from './about/about.module';
import * as operatorsModule from './operators/operators.module';
import * as TransportLocationsModule from './transport-locations/transport-locations.module';
import * as AbtModule from './abt/abt.module';
import * as CustomersModule from './customers/customers.module';
import * as CatalogueModule from './catalogues/catalogue.module';
import * as FulfilmentModule from './fulfilment/fulfilment.module';

export const initialise = () => {
  UserModule.initialise();
  HomeModule.initialise();
  aboutModule.initialise();
  TransportLocationsModule.initialise();
  operatorsModule.initialise();
  AbtModule.initialise();
  CustomersModule.initialise();
  CatalogueModule.initialise();
  FulfilmentModule.initialise();

  /**
   * This module serves as a manifest detailing the major feature areas of the application
   */
  angular.module('app.features', [
    'app.about',
    'app.user',
    'app.home',
    'app.operators',
    'app.transport-zones',
    'app.transport-locations-upload',
    'actora.catalogue',
    'actora.customers',
    'actora.fulfilment',
    'actora.abt',
  ]).constant('regexPatterns', {
    TIME: '([01]?[0-9]{1}|2[0-3]{1}):[0-5]{1}[0-9]{1}',
    NUMBER: '[0-9]{1,5}'
  });
};